import { TkSideBarProps } from "../../../type/componentsType/TkSideBar";
import SearchIcon from "@mui/icons-material/Search";
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import BarChartIcon from "@mui/icons-material/BarChart";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import { routes } from "../../../routes/kikoSyokuinPagesDef";

const iconList = [
  {
    icon: <SearchIcon />,
    label: "照会する",
  },
  {
    icon: <TextSnippetOutlinedIcon />,
    label: "申請・届出対応",
  },
  {
    icon: <SupportAgentIcon />,
    label: "代行入力対応",
  },
  {
    icon: <AssignmentIcon />,
    label: "掛金届・掛金納付状況管理",
  },
  {
    icon: <PermIdentityIcon />,
    label: "退職者状況管理",
  },
  {
    icon: <CurrencyYenIcon />,
    label: "収納・納付請求処理",
  },
  {
    icon: <AssuredWorkloadIcon />,
    label: "補助金管理",
  },
  {
    icon: <BarChartIcon />,
    label: "業務状況管理",
  },
  {
    icon: <PersonIcon />,
    label: "アカウント管理",
  },
  {
    icon: <EmailIcon />,
    label: "コミュニケーション",
  },
  {
    icon: <ImportContactsIcon />,
    label: "その他",
  },
];

const mapRoutesToSidebarData = (routes: any[]): TkSideBarProps[] => {
  const sidebarData: any = {};

  routes.forEach(route => {
    const title = route.meta.sideBarContentTitle;

    if (!title) return;

    if (!sidebarData[title]) {
      sidebarData[title] = {
        icon: iconList.find(item => item.label === title)?.icon,
        key: title,
        label: title,
        children: [],
      };
    }

    if (route.meta.isMenuContent) {
      sidebarData[title].children.push({
        key: route.name,
        label: route.meta.sideBarContentAsTitle ? route.meta.sideBarContentAsTitle : route.meta.title,
        url: route.path,
        bussinessType: route.meta.setBusinessType,
      });
    }
  });

  return Object.values(sidebarData);
};

const sideBarMenuData: TkSideBarProps[] = mapRoutesToSidebarData(routes);

export { sideBarMenuData };
